import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import {
  getIdentity,
  getMyGroups,
  subscribeCurrentIdentityToGroups,
} from "../../actions/api";
import RoleGroupsModal from "./RoleGroupsModal";
import { connect, useDispatch } from "react-redux";
import { SignatureOutlined } from "@ant-design/icons";
import { clearMyGroups, getMyRequests } from "../../actions";

const SubscribeToApplicationButton = ({
  // props
  subscribedRole,
  application,
  groupForSubscription,
  // prop methods
  onChange,
  identity,
  getIdentity,
  myPendingRequests,
  getMyRequests,
  getMyGroups,
  myGroups,
  clearMyGroups,
}) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [isPendingModeration, setIsPendingModeration] = useState(false);

  useEffect(() => {
    if (!identity) getIdentity();
  }, [getIdentity, identity]);

  useEffect(() => {
    if (!myGroups || myGroups.length <= 0) getMyGroups();
  }, [getMyGroups, myGroups]);

  useEffect(() => {
    if (!myPendingRequests) getMyRequests();
  }, [getMyRequests, myPendingRequests]);

  useEffect(() => {
    if (myGroups && myGroups.length > 0) {
      setIsPending(myGroups.some((x) => groupForSubscription === x.id));
    }
  }, [myGroups, groupForSubscription]);

  useEffect(() => {
    if (myPendingRequests) {
      setIsPendingModeration(
        myPendingRequests.some((x) => groupForSubscription === x.targetId1),
      );
    }
  }, [myPendingRequests, groupForSubscription]);

  const clear = () => {
    setVisible(false);
  };

  const openUpdateModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    clear();
  };

  const handleOk = async (group) => {
    await dispatch(subscribeCurrentIdentityToGroups([{ id: group }]));
    if (onChange) {
      await clearMyGroups();
      onChange();
    }
    setVisible(false);
  };

  return (
    <>
      <Button
        icon={<SignatureOutlined />}
        type="text"
        size="middle"
        onClick={openUpdateModal}
        disabled={isPending || isPendingModeration}
      >
        {isPending || isPendingModeration ? "Pending" : "Subscribe"}
      </Button>
      <RoleGroupsModal
        visible={visible}
        application={application}
        subscribedRole={subscribedRole}
        handleCancel={handleCancel}
        handleOk={handleOk}
        groupForSubscription={groupForSubscription}
      />
    </>
  );
};

SubscribeToApplicationButton.propTypes = {
  subscribedRole: PropTypes.string.isRequired,
  application: PropTypes.object.isRequired,
  groupForSubscription: PropTypes.string,
  onChange: PropTypes.func,
  identity: PropTypes.object,
  getIdentity: PropTypes.func.isRequired,
  myPendingRequests: PropTypes.array,
  getMyRequests: PropTypes.func.isRequired,
  getMyGroups: PropTypes.func.isRequired,
  myGroups: PropTypes.array,
  clearMyGroups: PropTypes.func.isRequired,
};

// export default SubscribeToApplicationButton;
export default connect(
  (state, props) => ({
    subscribedRole: props.subscribedRole,
    application: props.application,
    groupForSubscription: props.groupForSubscription,
    identity: state.identity,
    myPendingRequests: (state.requests.my || []).filter(
      (r) => r?.status === "Pending",
    ),
    myGroups: state.myGroups?.data,
  }),
  {
    getIdentity,
    getMyRequests,
    getMyGroups,
    clearMyGroups,
  },
)(SubscribeToApplicationButton);
